import React from 'react';
import { Link } from 'react-router-dom';
import { WEB_APP_URL } from '../../utils/webApp';
import './Footer.css';

const APP_STORE_URL = 'https://apps.apple.com/app/id6747190886';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.voia.travel.mobile';

const Footer = ({ variant = 'white' }) => {
  return (
    <footer className={`appFooter appFooter--${variant}`}>
      <div className="appFooterLinks">
        <Link to="/">Home</Link>
        {/* Same label as the Navbar, so the two read as one destination. */}
        <Link to="/visited-countries-map">My Map</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/privacy-policy">Privacy</Link>
        <Link to="/terms-of-service">Terms</Link>
        <a href={WEB_APP_URL}>Log in</a>
      </div>
      <div className="appFooterStores">
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img src="/assets/app_store_badge.svg" alt="Download VOIA on the App Store" />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img src="/assets/google_play_badge.png" alt="Get VOIA on Google Play" />
        </a>
      </div>
      <p>&copy; 2026 VOIA Travel. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
